import {MoneycardOtlRuleManagement} from '~/shared/store/models';
import {getOtlRuleManagement} from '~/shared/services/bffService/api';
import {is401Error} from '~/shared/services/apiErrorService';
import {handleRefreshToken} from '~/shared/services/auth';

export const getMoneycardOtlRuleManagementData = async (cardId: string): Promise<MoneycardOtlRuleManagement | null> => {
  try {
    return await getOtlRuleManagement(`${cardId}`);
  } catch (error) {
    if (is401Error(error)) {
      return handleRefreshToken(error, getMoneycardOtlRuleManagementData, cardId);
    }

    throw error;
  }
};

export const getOtlRuleCardId = (otlData: MoneycardOtlRuleManagement) => {
  const {userCreditcards, otlRule} = otlData;
  const sortedCards = userCreditcards?.sort((a, b) => b.creditcardId - a.creditcardId);
  return otlRule?.ruleActive && otlRule?.creditcardId && sortedCards.some(c => c.creditcardId === otlRule?.creditcardId && !c.isExpired)
    ? otlRule?.creditcardId
    : sortedCards && sortedCards[0]?.creditcardId;
};
